import { useDevRevSessionToken } from '@api/devRev';
import React from 'react';
import { IChatBubbleContext } from 'types/devRev';
import DevRevButton from './DevRevButton';
import DevRevWidgetScript from './DevRevWidgetScript';
import ChatBubbleContext from './SupportBubbleContext';

const SupportBubble = () => {
	const { data: sessionToken, isLoading } = useDevRevSessionToken();
	const [initialized, setInitialized] = React.useState(false);
	const { shouldOpen } =
		React.useContext<IChatBubbleContext>(ChatBubbleContext);

	React.useEffect(() => {
		if (shouldOpen) {
			setInitialized(true);
		}
	}, [shouldOpen]);

	if (isLoading || !sessionToken) {
		return null;
	}

	return initialized ? (
		<DevRevWidgetScript sessionToken={sessionToken} />
	) : (
		<DevRevButton onClick={() => setInitialized(true)} />
	);
};

export default SupportBubble;
